const BASE_URL = process.env.REACT_APP_BASE_EXPRESS_URL;

const axiosInstance = async ({ method = 'GET', url, data, headers = {}, responseType }) => {
  const options = {
    method: method.toUpperCase(),
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (data && method.toUpperCase() !== 'GET') {
    options.body = typeof data === 'string' ? data : JSON.stringify(data);
  }

  const response = await fetch(`${BASE_URL}${url}`, options);

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.response = { status: response.status, statusText: response.statusText };
    throw error;
  }

  let responseData;
  if (responseType === 'blob') {
    responseData = await response.blob();
  } else if (responseType === 'arraybuffer') {
    responseData = await response.arrayBuffer();
  } else {
    const contentType = response.headers.get('content-type');
    responseData = contentType && contentType.includes('application/json')
      ? await response.json()
      : await response.text();
  }

  return { data: responseData };
};

export default axiosInstance;
